import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function UiuxServies() {
    const features = [
        {
            title: 'Wire-framing & Prototyping',
            description:
                'We help enterprises create a robust digital experience with conceptual wireframes and interactive prototypes. By thoroughly analyzing the core features and design workflow, we incorporate all visual and functional elements that improve navigation and usability.',
            icon: '/img/technology/ic-wireframe.svg',
        },
        {
            title: 'Web User Experience Design',
            description:
                'Moweb provides user experience design services for customer-centric experiences. We focus on user research, analysis, UI design, prototyping, usability, accessibility evaluation, user journey mapping, user flows, and testing to minimize development efforts and costs.',
            icon: '/img/technology/ic-user-experience-design.svg',
        },
        {
            title: 'User Interface Design',
            description:
                'Our user interface designers can create an intuitive and user-friendly interface for your website, app, or other digital product. With our expert user interface design services, you can deliver amazing user experiences that engage, delight, and convert.',
            icon: '/img/technology/ic-user-interface.svg',
        },
        {
            title: 'Responsive Design',
            description:
                'We are experts in designing and developing custom portals for diverse industries such as eCommerce, resource management, enterprise management, and more. Hire dedicated UI/UX developers from Moweb for customized business portal development.',
            icon: '/img/technology/ic-responsive-design.svg',
        },
        {
            title: 'Mobile App Design',
            description:
                'Our mobile app design services can turn your concept into an interactive engaging application. We create mobile apps that align with your brand\'s color scheme, typography, and graphics, resulting in a fully functional and visually appealing product.',
            icon: '/img/technology/ic-mobile-app.svg',
        },
        {
            title: 'Branding & Graphic Design',
            description:
                'We offer holistic branding and graphic design services to create marketing collateral, logos, and prints to help your company stand out. Our skilled designers assist clients in connecting their brand identity with customers through printed and digital materials',
            icon: '/img/technology/ic-brand-graphic-design.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                UI/UX Design Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid features={features} variant="grey" />
                </div>
            </div>
        </>
    );
}

export default UiuxServies;